import { HTMLAttributes, useMemo } from "react";
import { useDownloadDocument } from "api/documents/useDownloadDocument";
import { isValidUrl } from "utils/url";

interface DownloadableDocumentProps extends HTMLAttributes<HTMLAnchorElement> {
  label: string;
  url?: string | null;
  /**
   * When documentIdentifier is present, clicking on the link will download the document or open it in a new tab if the name ends with .link
   * When documentIdentifier is not present, clicking on the link will open the url in a new tab
   */
  documentIdentifier?: string;
  id?: string;
}

export const DownloadableDocument = ({
  label,
  url,
  documentIdentifier,
  id,
  ...anchorAttributes
}: DownloadableDocumentProps) => {
  const { downloadDocument } = useDownloadDocument();

  const isValidURL: boolean = useMemo(() => !!url && isValidUrl(url), [url]);
  // remove .link file extension from label if present
  const labelCleaned = label.endsWith(".link") ? label.slice(0, -5) : label;

  const linkAttributes: JSX.IntrinsicElements["a"] = !documentIdentifier
    ? {
        target: "_blank",
        rel: "noopener noreferrer",
        href: url || undefined,
      }
    : {
        href: "#",
        onClick: (e) => {
          e.preventDefault();
          downloadDocument(documentIdentifier, "base64");
        },
      };

  return isValidURL || documentIdentifier ? (
    <a {...linkAttributes} {...anchorAttributes} className="inline-flex justify-between text-secondary-80 stroke-secondary-80" id={id}>
      <div className="">{labelCleaned}</div>
      <span className="text-[20px] mgc_document_2_line" />
    </a>
  ) : null;
};
